/**
 * @generated SignedSource<<320160c7d971df546b6542e0bbee5b7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductKind = "CONSUMABLE" | "ITEM" | "KIT" | "%future added value";
export type OpsProductsPageQuery$variables = Record<PropertyKey, never>;
export type OpsProductsPageQuery$data = {
  readonly products: ReadonlyArray<{
    readonly category: string;
    readonly forProduct: {
      readonly id: string;
    } | null | undefined;
    readonly id: string;
    readonly kind: ProductKind;
    readonly lowStock: boolean;
    readonly make: string | null | undefined;
    readonly model: string | null | undefined;
    readonly name: string;
    readonly packSize: string | null | undefined;
    readonly price: any | null | undefined;
    readonly properties: any;
    readonly quantityOnHand: number;
    readonly rentable: boolean;
    readonly reorderLevel: number;
    readonly slug: string;
    readonly unit: string | null | undefined;
  }>;
};
export type OpsProductsPageQuery = {
  response: OpsProductsPageQuery$data;
  variables: OpsProductsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Product",
    "kind": "LinkedField",
    "name": "products",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "make",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "model",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rentable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "packSize",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quantityOnHand",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reorderLevel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lowStock",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "properties",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "forProduct",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsProductsPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OpsProductsPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b8d64278f04ad380d7b9c56478361983",
    "id": null,
    "metadata": {},
    "name": "OpsProductsPageQuery",
    "operationKind": "query",
    "text": "query OpsProductsPageQuery {\n  products {\n    id\n    slug\n    kind\n    name\n    make\n    model\n    category\n    rentable\n    price\n    unit\n    packSize\n    quantityOnHand\n    reorderLevel\n    lowStock\n    properties\n    forProduct {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "90528e4e367633e682c7b52563150c06";

export default node;
